/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const aiSuggestionAcceptAllResponseSchema = z.object({
  appliedCount: z.int(),
  notAppliedIds: z.array(z.int()),
});
